// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-download {
    cursor: pointer;
    vertical-align: middle;
    display: flex;
    padding: 3px 0;
    color: #c11e07;
    line-height: 1.5rem;
}

.aiiif-download svg {
    margin-right: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/infoBar/tabs/download.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".aiiif-download {\n    cursor: pointer;\n    vertical-align: middle;\n    display: flex;\n    padding: 3px 0;\n    color: #c11e07;\n    line-height: 1.5rem;\n}\n\n.aiiif-download svg {\n    margin-right: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
